import styled, { css } from "styled-components";

export const Popover = styled.div`
  border-radius: 3px;
  width: 220px;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 0px 6px;
  padding: 20px;
  font-size: 13px;
  font-weight: 400;
  color: #212121;
  display: none;
  text-align: left;
  z-index: 5;
  opacity: 0;
  transition: 0.1s opacity 0.1s cubic-bezier(0.55, 0.3, 0.5, 0.9);

  ${props =>
    props.active &&
    css`
      display: block;
      opacity: 1;
    `}

  &:before {
    top: -26px;
    left: -18px;
    z-index: 2;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 6px solid #fff;
    content: "";
    position: relative;
    display: block;
    width: 0;
    height: 0;
  }
  span {
    margin-top: 8px;
    font-size: 13px;
    display: block;
    color: #515151;
  }

  a {
    display: block;
    font-size: 13px;
    margin-top: 8px;
    color: #44adf8;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  &:focus {
    outline: none;
  }
`;

export const LabelWrapper = styled.div`
  ${({ fontSize }) => `font-size: ${fontSize}px`}
  ${props =>
    props.withTooltip &&
    css`
      display: flex;
      div {
        margin-right: 8px;
      }
  `}
`;

export const TooltipWrapper = styled.span`
  position: absolute;
  z-index: 5;

  span.trigger {
    cursor: pointer;
    margin-bottom: 10px;
  }
`;